import { Link } from 'react-router-dom';

const features = [
  { icon: 'ri-search-eye-line', title: '多维筛选', desc: '按类型、地区、年份与热度快速缩小范围' },
  { icon: 'ri-file-text-line', title: '图文介绍', desc: '每部作品附完整简介、主创与观看信息说明' },
  { icon: 'ri-heart-3-line', title: '本地片单', desc: '收藏保存在你的浏览器，无需注册即可使用' },
  { icon: 'ri-newspaper-line', title: '资讯聚合', desc: '新片消息、影评解读与行业观察一站获取' },
];

export default function BrandIntro() {
  return (
    <section className="w-full bg-background-100/70 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto w-full max-w-[1400px]">
        <div className="grid grid-cols-1 gap-8 rounded-lg border border-background-200/70 bg-background-50 p-6 md:p-9 lg:grid-cols-[1fr_1.2fr] lg:items-center">
          <div>
            <p className="font-label text-xs uppercase tracking-[0.2em] text-accent-600">About 91大神</p>
            <h2 className="mt-2 font-display text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
              为爱看片的人，做一份更清楚的影视索引
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              91大神影视平台是一个面向影视爱好者的内容聚合站点。我们把电影、剧集与综艺整理成结构清晰的分类与标签，配合真实的筛选条件和信息说明，帮助你在几分钟内决定今晚看什么。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              本站不提供播放器与下载入口，播放相关信息仅以文字与图片形式说明，实际可观看的平台、清晰度与版本请以对应平台说明为准。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="whitespace-nowrap rounded-md bg-primary-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-800"
              >
                了解平台定位
              </Link>
              <Link
                to="/category/movie/list?sort=评分最高"
                className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
              >
                从高分开始 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {features.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200/70 bg-background-100 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-base`}></i>
                </span>
                <h3 className="mt-2.5 text-sm font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-500">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}